<template>
  <FormulateForm
    ref="form"
    name="form"
  >
    <e-sidebar
      id="sidebar-stock-counting"
      :title="$t('Nova Contagem de Estoque')"
      :show="showSidebar"
      :fetching="fetching"
      :saving="saving"
      width="500px"
      @save="onSaveCounting"
      @hidden="showSidebar = false"
    >
      <template #content>
        <b-row>
          <b-col md="12">
            <e-store-combo
              v-model="form.storeId"
              required
              :only-active-options="true"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="counting-description"
              v-model="form.description"
              type="textarea"
              :label="$t('Descrição')"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="product-group-id"
              v-model="form.groupId"
              :label="$t('Grupo')"
              type="vue-select"
              :placeholder="$t('Selecione')"
              :options="getComboGroups"
              @input="onGroupChange"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="product-subgroup-id"
              v-model="form.subgroupId"
              type="vue-select"
              :label="$t('Subgrupo')"
              :placeholder="$t('Selecione')"
              :options="getComboSubgroups"
              :disabled="!form.groupId"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="product-brand-id"
              v-model="form.brandId"
              :label="$t('Marca')"
              type="vue-select"
              :placeholder="$t('Selecione')"
              :options="getComboBrands"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="product-department-id"
              v-model="form.departmentId"
              :label="$t('Departamento')"
              type="vue-select"
              :placeholder="$t('Selecione')"
              :options="getComboDepartments"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              v-model="form.productClassifications"
              name="productClassifications"
              type="vue-select"
              :label="$t('Classificações de produto')"
              :placeholder="$t('Selecione')"
              :options="productClassificationsForInventory()"
              :instruction="$t('Selecione uma ou mais classificações de produtos')"
              multiple
            />
          </b-col>
        </b-row>
      </template>
    </e-sidebar>
  </FormulateForm>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { ESidebar } from '@/views/components'
import { formulateHelper, productDomains } from '@/mixins'
import { mapGetters, mapActions } from 'vuex'
import EStoreCombo from '@/views/components/inputs/EStoreCombo.vue'
import axios from '@axios'

const getInitialForm = () => ({
  storeId: null,
  groupId: null,
  subgroupId: null,
  brandId: null,
  departmentId: null,
  description: null,
  productClassifications: [],
})

export default {
  components: { BRow, BCol, ESidebar, EStoreCombo },

  mixins: [formulateHelper, productDomains],

  data() {
    return {
      showSidebar: false,
      fetching: false,
      saving: false,
      form: getInitialForm(),
    }
  },

  computed: {
    ...mapGetters('pages/catalog/products', [
      'getComboDepartments',
      'getComboBrands',
      'getComboGroups',
      'getComboSubgroups',
    ]),
  },

  watch: {
    showSidebar(val) {
      if (val) {
        this.form = getInitialForm()
      }
      this.$refs.form.hideErrors()
    },
  },

  async mounted() {
    this.fetching = true
    try {
      await this.fetchProductCombos()
    } finally {
      this.fetching = false
    }
  },

  methods: {
    ...mapActions('pages/catalog/products', ['setComboSubgroups', 'fetchProductCombos']),

    onGroupChange(groupId) {
      this.form.subgroupId = null
      this.setComboSubgroups(groupId)
    },

    async onSaveCounting() {
      this.$refs.form.showErrors()
      if (this.$refs.form.isValid) {
        try {
          this.saving = true
          const { data } = await axios.post('/api/stock-countings', this.form)
          this.showSuccess({ message: this.$t('Contagem criada com sucesso') })
          this.showSidebar = false
          this.$emit('save', data)
        } catch (error) {
          this.showError({ error, message: this.$t('Não foi possível concluir a operação') })
        } finally {
          this.saving = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
